/**
 * @centralhub/validation — shared, zero-dependency field-format predicates.
 *
 * Single authoritative source for EMAIL_REGEX, isValidEmail, and isPlausiblePhone.
 * Previously duplicated (byte-identical) across:
 *   - chat-widget/src/lib/validation.ts
 *   - sites-platform/components/behavior/src/dom-utils.ts
 *
 * No dependencies — safe to import from both the Vite-bundled chat-widget and
 * the esbuild-bundled behavior bundle.
 *
 * The backend does authoritative validation; these helpers only catch obvious
 * typos before a round-trip.
 */
/**
 * Lenient email regex.
 *
 * The backend does authoritative validation; this only catches obvious typos
 * before a round-trip.
 */
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
/**
 * Return true when `value` looks like a syntactically valid email address.
 *
 * @param value  Trimmed email string to test.
 */
export function isValidEmail(value) {
    return EMAIL_REGEX.test(value);
}
/**
 * Return true when `value` looks like a plausible phone number.
 *
 * Accepts common formatting characters (spaces, dashes, parentheses, dots) and
 * an optional leading "+". Requires at least 7 and at most 15 digits total
 * (ITU-T E.164 bounds). The backend normalises to E.164; this only catches
 * obvious non-numbers (e.g. "abc", "123") before the round-trip.
 *
 * Accepts: "(650) 282-5887", "650 282 5887", "+1 650-282-5887", "+447911123456"
 * Rejects: "abc", "123", "12345", ""
 *
 * @param value  Trimmed phone string to test.
 */
export function isPlausiblePhone(value) {
    // Strip everything except digits and a single leading "+".
    const stripped = value.replace(/(?!^\+)[^\d]/g, "");
    const digits = stripped.replace(/^\+/, "").replace(/\D/g, "");
    return digits.length >= 7 && digits.length <= 15;
}
//# sourceMappingURL=index.js.map